import { MutationTree } from 'vuex';
import { BoothsState, Booth } from '@/store/booths/types';
import { Pager } from '../pager.types';

const mutations: MutationTree<BoothsState> = {
  fetchedBooths: (state, payload: {
    pager: Pager,
    booths: Booth[],
  }) => {
    state.booths = payload.booths
    state.pager = payload.pager
  },
  fetchedAllBoothsCount: (state, payload: {
    allCountForCsvDownload: Number,
  }) => {
    state.allCountForCsvDownload = payload.allCountForCsvDownload
  },
};

export default mutations;
